module.exports = __webpack_public_path__ + "img/about-icon1.7be04888.png";